// extracted by mini-css-extract-plugin
export var icon = "BlackHalvaLogoV2-module--icon--1MnO9";